import { State } from '@hookstate/core';
import React from 'react';
import { attributesType, mediaType } from '../../libs/typeInterface';
import InnerDetails from './InnerDetails';
import ProductSlider from './ProductSlider';

interface IProductTitle {
  media: mediaType[];
  name: string;
  size: string;
  shortDesc: string;
  attributes: attributesType[];
  price: number;
  mrp: number;
  link: string;
  setShowZoomModal: (x: boolean) => void;
  setInitialImage: (x: mediaType) => void;
  openRedirectModal: State<boolean>;
  productType?: string;
}

const ProductTitle = (props: IProductTitle) => {
  const {
    media,
    name,
    size,
    shortDesc,
    attributes,
    price,
    mrp,
    link,
    setShowZoomModal,
    setInitialImage,
    openRedirectModal,
    productType
  } = props;
  return (
    <>
      <section className="xs:px-4 lg:px-0 relative w-full flex flex-col items-center justify-center lg:container lg:mx-auto mb-8">
        <div className="w-full flex xs:flex-col lg:flex-row">
          <div className="xs:w-full lg:w-1/2 flex items-center justify-center">
            <ProductSlider
              setShowZoomModal={setShowZoomModal}
              setInitialImage={setInitialImage}
              name={name}
              media={media}
            />
          </div>
          <div className="xs:w-full lg:w-1/2 xs:mt-1 lg:mt-0 flex items-center justify-center">
            <InnerDetails
              name={name}
              size={size}
              shortDesc={shortDesc}
              attributes={attributes}
              price={price}
              mrp={mrp}
              link={link}
              openRedirectModal={openRedirectModal}
              productType={productType}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductTitle;
